const flying_jelly = (level) => {
  const handle = 'flying_jelly';
  const types = ['amorphous', 'flying', 'jelly'];
  const bags = [];
  const AI_PRIORITIES = ['interference', 'dps_close', 'tank', 'support', 'dps_ranged'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'adrenaline' },
    { value: 'leap' },
    { value: 'psyche_out' },
    { value: 'roundhouse' },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'flying_jelly_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          adrenaline: {
            handle: 'adrenaline',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          leap: {
            handle: 'leap',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          psyche_out: {
            handle: 'psyche_out',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          roundhouse: {
            handle: 'roundhouse',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(6 + bound_level * 0.8 + Math.random() * 3),
      perception: Math.round(6 + bound_level * 0.7 + Math.random() * 3),
      mana: Math.round(12 + bound_level * 1.6 + Math.random() * 3),
      toughness: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      willpower: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      dexterity: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 1350,
    drops_gold: false,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = flying_jelly;
